@if (tippingConfig()?.is_tipping_enabled) {
    <div class="tip border-line">
        <label>{{ tippingConfig()?.name | translate }}</label>
        <div>
            @if (tippingConfig()?.options?.length) {
                <div class="option-slider">
                    @for (opt of tippingConfig()?.options; track $index) {
                        <div 
                            (click)="applyPercentageTip(opt.percentage, $index)"
                            [class.selected]="selectedIndex() === $index"
                        >
                            <span>{{ opt.percentage | number }}%</span>
                        </div>
                    }
                </div>
            }
            
            <!-- <p>{{ 'TIP.CUSTOM_AMOUNT' | translate }}</p> -->
            <div class="input-btn-box">
                <div class="box">
                    <input 
                    type='number' 
                    [value]="tip()"
                    (input)="tip.set($event.target.value ? +$event.target.value : null)"
                    placeholder="{{ 'TIP.PLACEHOLDER' | translate }}" 
                    />
                    <button class="btn" 
                        mat-raised-button 
                        type="button" 
                        (click)="applyTip()">
                        {{ 'TIP.ADD' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
}